import { createAction, props } from "@ngrx/store";
import { PackageFilter } from "../../models/packageFilter";

export const setPackageFilter = createAction(
    "[Package Filter Component] Set Package Filter",
    props<{ filter: PackageFilter }>(),
);

export const clearPackageFilter = createAction("[Package Filter Component] Clear Package Filter");
